import { api } from './client';
import { safeHttpUrl } from '../utils/safe-url';

export interface FaqEntry { id: string; question: string; answer: string; category: string | null; sortOrder: number; }
export interface LegalPage { id: string; slug: string; title: string; body: string; updatedAt: string; }
export interface SocialLink { id: string; platform: string; url: string; }
// Admin-enabled payment rails in display order; `icon` is an optional image URL for custom rails.
export interface PaymentMethod { slug: string; name: string; icon?: string; }

export const fetchPublicFaq = () => api.get<FaqEntry[]>('/cms/faq').then(r => r.data);
export const fetchLegalPage = (slug: string) => api.get<LegalPage>(`/cms/legal/${slug}`).then(r => r.data);
/** Rendered as `<a href>` in the topbar and footer: links that are not absolute http(s) are dropped. */
export const fetchSocialLinks = () => api.get<SocialLink[]>('/cms/social-links').then(r => safeSocialLinks(r.data));

export function safeSocialLinks(links: SocialLink[]): SocialLink[] {
  return links.flatMap((link) => {
    const url = safeHttpUrl(link.url);
    return url ? [{ ...link, url }] : [];
  });
}
export const fetchPaymentMethods = () => api.get<PaymentMethod[]>('/cms/payment-methods').then(r => r.data);

/** Home page optional sections (AppSetting `home.sections`); missing key = shown. */
export type HomeSections = Record<'recent' | 'priceTiles' | 'deals' | 'platforms' | 'giftCards' | 'howItWorks' | 'newest' | 'genres' | 'promos' | 'journal', boolean>;
export const fetchHomeSections = () => api.get<HomeSections>('/cms/home-sections').then(r => r.data);
